import React from "react";

const WhatIsUSCYPage = () => {
  return (
    <section>
      <p>
        What is USCY? USCY is an institutional-grade USD stablecoin and
        settlement infrastructure designed for regulated financial institutions.
        When an institution mints USCY, the cash deposit does not simply
        disappear into an issuer balance sheet. Instead, it forms a dedicated
        collateral vault held in a Delaware Statutory Trust (the USCY Reserves
        Trust) and custodied by Northern Trust. That vault accrues the
        institution&apos;s share of risk-free yield, net of platform fees, until
        it is closed via redemption. USCY is issued through a regulated US money
        services business (MSB), currently Brale, while the USCY Reserves Trust
        legally owns the reserves and Northern Trust safekeeps the cash. This
        separation of issuer, custodian and trust provides bankruptcy-remote
        protection and institutional-grade governance that goes beyond most
        existing stablecoin models. The problem USCY solves Today&apos;s
        regulated 1:1 stablecoins, including those with affiliate-style reward
        schemes, share a structural flaw: Minting is treated as a simple swap:
        institutions deliver cash and receive tokens. The issuer retains full
        economic rights to the collateral yield. Any yield returned to users is
        delivered through revocable, programme-based rewards aimed at token
        holders, not the original minters. Once a stablecoin is used
        operationally—traded, pledged, or posted into settlement workflows—the
        original depositor effectively forfeits the economic benefit of the
        yield generated by their own collateral. Yield is decoupled from the
        actor who created supply and liquidity in the first place. USCY takes
        the opposite approach. It is architected around the minter, not the
        issuer. Vaults: yield follows the original deposit, not the token
        balance When an institution mints USCY: The deposit is placed into a
        dedicated collateral vault inside the USCY Reserves Trust. That vault
        tracks the institution&apos;s share of the collateral yield, net of
        platform fees. The vault continues to accrue yield until it is closed
        through redemption. Crucially: Yield is based on the original deposit,
        not the institution&apos;s current USCY token balance. Institutions can
        use USCY freely across trading, treasury, collateral and settlement
        workflows without breaking their economic link to the underlying
        collateral. This design maintains economic continuity even in
        high-velocity environments such as off-exchange settlement (OES). The
        USCY token itself remains a simple 1:1 redeemable stablecoin. All of the
        complexity around yield, duration and queue position sits in the vault
        and YPP layer, not in the token. The redemption queue: front is bad,
        rear is good USCY uses a transparent, queue-based redemption model to
        determine how long a vault remains active. All vaults sit in a
        redemption queue. Vaults at the front of the queue are next to be closed
        to honour redemption requests. When a vault is closed, its associated
        yield stream stops. The institution recovers principal in cash; the
        vault has completed its lifecycle. Vaults in the middle of the queue are
        in a neutral zone. Vaults at the rear of the queue are best protected
        and can continue earning for the longest time. Intuitively: Front of the
        queue → short remaining duration, high liquidation risk. Rear of the
        queue → long remaining duration, low liquidation risk. Every institution
        is effectively playing to stay away from the front. The queue makes that
        trade-off explicit and visible. From day one, the platform exposes this
        clearly: A collateral positions dashboard (or “vaults dashboard”) shows
        each vault, its band (front / middle / rear) and its exact ranking. The
        system can also estimate the impact on ranking before an institution
        chooses to spend YPPs to protect a particular vault. For more detail,
        see: /kb/vaults-and-ranking and /kb/redeem. Redemption and the 1:1 peg
        Redemption is straightforward: eligible institutions return USCY and
        receive USD (or equivalent cash) at or around 1:1, subject to programme
        terms. Behind the scenes: Redemptions are funded by closing vaults at
        the front of the queue. When a vault is used to honour a redemption, it
        is closed and stops earning yield. The USCY token remains a fully-backed
        1:1 redeemable instrument; the vault system and YPPs operate alongside
        it and do not introduce yield into the token itself. This design aligns
        with frameworks like the GENIUS Act by attaching yield to the underlying
        collateral vaults, not to the stablecoin balances, while preserving a
        clean, trust-based reserve model. Where YPPs fit: pricing optionality
        over vault duration Some institutions will simply accept the default
        queue and vault lifecycle. Others—especially those with large or
        strategically important deposits—will want greater control over how long
        specific vaults remain active. That is the role of Yield Protection
        Points (YPPs). YPPs are issued by an independent YPP Foundation in the
        Cayman Islands. They are non-yield-bearing, non-governance, and not
        reward payouts. Their purpose is to price optionality over vault
        duration. By spending YPPs, an institution can: Move a vault further
        back in the queue, Extend its remaining duration, and Reduce the
        likelihood that it will be used to honour redemptions in the near term.
        The more YPPs spent relative to others, within programme rules, the more
        favourable the vault&apos;s position. This creates a transparent,
        free-market for vault-duration rights inside a regulated, GENIUS-aligned
        framework—without modifying the issuance, redemption or regulatory
        treatment of USCY itself. For a deeper dive, see /kb/ypp-overview and
        /kb/ypp-ecosystem-role. Who USCY is for USCY is designed for regulated
        institutions, not retail users. Typical adopters include: Digital asset
        hedge funds and trading firms Professional market makers Custody
        platforms and qualified custodians Settlement venues and OES networks
        Banks and broker-dealers operating digital asset businesses Corporate
        treasuries using tokenised cash for internal settlement These
        institutions require: Bank-grade custody for reserves Bankruptcy-remote
        segregation of client assets Regulated issuance via a licensed MSB A
        stablecoin that integrates with existing API-based treasury, collateral
        and settlement systems USCY is built to fit directly into these
        workflows with a cloud-hosted, API-first integration model. Key
        differentiators (at a glance) USCY is differentiated from incumbents
        (e.g. USDC, Paxos, PayPal USD) in four key ways: Minter-centric design
        Vaults ensure that yield follows the original deposit, not the token
        balance. Minter economics are preserved end-to-end across workflows.
        Trust-based, custodied reserves Reserves are held by the USCY Reserves
        Trust and custodied by Northern Trust. The trust is designed to be
        bankruptcy-remote, further reducing issuer risk. Queue-based redemption
        with optional duration control A transparent redemption queue ensures
        every vault runs a clear lifecycle. YPPs provide a regulated,
        market-based mechanism for managing vault duration without touching the
        token&apos;s regulatory profile. Workflow-native design USCY is built
        for OES, treasury, collateral and settlement use cases where balances
        may move quickly but institutions still care about long-term economics
        on the original deposit. In short: USCY is a settlement-ready,
        institutional stablecoin that restores the economic link between minters
        and the yield on their collateral, while preserving a simple 1:1 token
        and clear regulatory treatment.
      </p>
    </section>
  );
};

export default WhatIsUSCYPage;
